
import { useRef } from 'react';

export default function FeaturedJobs() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const jobs = [
    {
      title: 'Senior Software Engineer',
      company: 'TechCorp Solutions',
      location: 'San Francisco, CA',
      type: 'Full-time',
      salary: '$120k - $180k',
      logo: 'https://readdy.ai/api/search-image?query=modern%20technology%20company%20logo%20minimalist%20design%20blue%20gradient%20abstract%20tech%20symbol%20professional%20corporate%20branding&width=80&height=80&seq=job-logo-001&orientation=squarish'
    },
    {
      title: 'Marketing Director',
      company: 'BrandVision Inc',
      location: 'New York, NY',
      type: 'Full-time',
      salary: '$100k - $150k',
      logo: 'https://readdy.ai/api/search-image?query=creative%20marketing%20agency%20logo%20colorful%20modern%20design%20abstract%20brand%20symbol%20professional%20corporate%20identity&width=80&height=80&seq=job-logo-002&orientation=squarish'
    },
    {
      title: 'Financial Analyst',
      company: 'Capital Partners',
      location: 'Chicago, IL',
      type: 'Full-time',
      salary: '$80k - $120k',
      logo: 'https://readdy.ai/api/search-image?query=financial%20services%20company%20logo%20professional%20elegant%20design%20gold%20and%20navy%20corporate%20symbol%20banking%20finance%20branding&width=80&height=80&seq=job-logo-003&orientation=squarish'
    },
    {
      title: 'Product Manager',
      company: 'InnovateLabs',
      location: 'Austin, TX',
      type: 'Full-time',
      salary: '$110k - $160k',
      logo: 'https://readdy.ai/api/search-image?query=innovative%20startup%20company%20logo%20modern%20geometric%20design%20purple%20gradient%20tech%20symbol%20professional%20branding&width=80&height=80&seq=job-logo-004&orientation=squarish'
    },
    {
      title: 'UX Designer',
      company: 'DesignStudio Pro',
      location: 'Seattle, WA',
      type: 'Contract',
      salary: '$90k - $130k',
      logo: 'https://readdy.ai/api/search-image?query=creative%20design%20studio%20logo%20artistic%20modern%20minimalist%20colorful%20abstract%20symbol%20professional%20branding&width=80&height=80&seq=job-logo-005&orientation=squarish'
    }
  ];

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = 320;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="py-20 lg:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="flex items-center justify-between mb-12">
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Latest Opportunities
            </h2>
            <p className="text-lg text-gray-600">
              Explore our current job openings across various industries
            </p>
          </div>
          
          {/* Navigation Arrows */}
          <div className="hidden lg:flex items-center gap-3">
            <button
              onClick={() => scroll('left')}
              className="w-12 h-12 flex items-center justify-center rounded-full bg-white border border-gray-300 text-gray-600 hover:border-teal-600 hover:text-teal-600 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line text-xl"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              className="w-12 h-12 flex items-center justify-center rounded-full bg-teal-600 text-white hover:bg-teal-700 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
          </div>
        </div>

        {/* Jobs Scroll Container */}
        <div
          ref={scrollRef}
          className="flex gap-6 overflow-x-auto pb-4 scrollbar-hide"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {jobs.map((job, index) => (
            <div
              key={index}
              className="flex-shrink-0 w-80 bg-white rounded-xl p-6 border border-gray-200 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              {/* Company Logo */}
              <div className="mb-4">
                <img
                  src={job.logo}
                  alt={job.company}
                  className="w-12 h-12 object-cover rounded-lg"
                />
              </div>

              {/* Job Title */}
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                {job.title}
              </h3>

              {/* Company Name */}
              <p className="text-gray-600 mb-4">{job.company}</p>

              {/* Tags */}
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="inline-flex items-center px-3 py-1 bg-gray-100 text-gray-700 text-sm rounded-full whitespace-nowrap">
                  <i className="ri-map-pin-line mr-1"></i>
                  {job.location}
                </span>
                <span className="inline-flex items-center px-3 py-1 bg-teal-100 text-teal-700 text-sm rounded-full whitespace-nowrap">
                  <i className="ri-time-line mr-1"></i>
                  {job.type}
                </span>
              </div>

              {/* Salary */}
              <div className="mb-4">
                <span className="text-lg font-bold text-gray-900">{job.salary}</span>
                <span className="text-gray-600 text-sm ml-1">per year</span>
              </div>

              {/* Apply Button */}
              <a
                href="#contact"
                className="inline-flex items-center text-teal-600 font-semibold hover:text-teal-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                Apply Now
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center mt-12">
          <a
            href="#contact"
            className="inline-flex items-center px-8 py-3 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            View All Opportunities
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
